// src/pages/KennelsPage.tsx
import React from 'react';
import { Box } from '@mui/material';
import KennelGrid from '../components/kennels/KennelGrid';
import VisuallyHiddenHeading from '../components/common/VisuallyHiddenHeading';

const KennelsPage: React.FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <VisuallyHiddenHeading title="Kennels" />
      <KennelGrid />
    </Box>
  );
};

export default KennelsPage;
